import { render, staticRenderFns } from "./ReportsDeliverySacAgcoPublicResultView.vue?vue&type=template&id=244cc272&scoped=true"
import script from "./ReportsDeliverySacAgcoPublicResultView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliverySacAgcoPublicResultView.vue?vue&type=script&lang=ts"
import style0 from "./ReportsDeliverySacAgcoPublicResultView.vue?vue&type=style&index=0&id=244cc272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244cc272",
  null
  
)

export default component.exports